import { Component } from 'react';
import {connect} from 'react-redux';
import {Col, Row} from 'react-bootstrap';
import {Errors, Form} from 'forms/rrf';
import ArrowButton from '../../../common/button-arrow';
import RequiredInput from '../../../common/form/elements/required-input';

class GroupForm extends Component {
  render() {
    const {formValid, model, onSubmit} = this.props;

    return (
      <div className="mg-bottom-60 mg-top-10">
        <div className="container-fluid">
          <Form model={model} onSubmit={onSubmit}>
            <Row>
              <Col md={12}>
                <Errors className="errors" model={model}/>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <RequiredInput
                  controlId='name'
                  label="Name"
                  model='.name'
                  placeholder="Name"
                />
              </Col>
            </Row>
            <Row>
              <Col md={{span: 2, offset: 10}}>
                <ArrowButton
                  arrow={false}
                  className="float-end"
                  disabled={!formValid}
                >
                  Save
                </ArrowButton>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_group_save.$form.valid,
});

export default connect(mapStateToProps)(GroupForm);
